import { colors } from '../../../../../colorVars';
import style from './BoxSwitch.module.css';

type Props = {
  title: string;
  fontSize: string;
  labels: string[];
  values: any[];
  setValue: (value: any) => void;
  controlledValue: any;
  margin?: string;
  disabled?: boolean;
  notSelectedColor:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  selectedColor:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  color:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  maxHeight?: string;
};

export const BoxSwitch = ({
  title,
  values,
  labels,
  setValue,
  controlledValue,
  margin,
  disabled,
  notSelectedColor,
  selectedColor,
  color,
  fontSize,
  maxHeight,
}: Props) => {
  return (
    <div
      className={style.container}
      style={{ margin, maxHeight }}
      title={title}
    >
      {labels.map((label, index) => {
        const value = values[index];
        return (
          <div
            key={label}
            className={style.box}
            style={{
              borderLeft:
                index !== 0 ? `0.5px solid rgba(255, 255, 255, 0.3)` : 'none',
              color: colors[color],
              backgroundColor: disabled
                ? colors.notSelected
                : controlledValue === value
                ? colors[selectedColor]
                : colors[notSelectedColor],
            }}
            onClick={() => {
              if (!disabled) setValue(value);
            }}
          >
            <span style={{ fontSize, margin: 'none', padding: 'none' }}>
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
};
